import Accordion from 'react-bootstrap/Accordion';
import CandidatureArbitrage from './candidatureArbitrage';
import ModificationCandidature from './modificationCandidature';
import StatutCandidatureArbitrage from './statutCandidatureArbitrage';

function ProchainMatchAffichage(props) {





  return (
    <>
    {props.equipe && (
        <>
            <Accordion defaultActiveKey="0">
            {props.equipe.ProchainMatch && props.equipe.ProchainMatch.map((item, index) => (
                      <Accordion.Item key={index}  eventKey={index}>
                            <Accordion.Header>
                               <div className="text-center mb-3">
                                  {item.equipe_dom} {item.score === null ? ('-'):(item.score)} {item.equipe_ext}<br/> {item.date} <br/> {item.competition}
                                </div>
                            </Accordion.Header>
                        <Accordion.Body>
                            {!props.equipe.arbitre | props.equipe.arbitre.every(items => items.id_match !== item.id_match) ? (
                                <>
                                    <CandidatureArbitrage userData={props.userData} equipe={item} />
                                </>
                            ) : (
                                <>
                                    {props.equipe.arbitre && props.equipe.arbitre.filter(items => items.id_match === item.id_match).map((Item, index) => (
                                                <div key={index}>
                                                    {Item.id_arbitre === props.userData.user.donnée.results[0].id && Item.status !== 'rejeter' && Item.status !== 'accepter' ? (
                                                        <>
                                                           <ModificationCandidature userData={props.userData} equipe={item} status={Item}/>
                                                        </>
                                                    ):(
                                                        <>
                                                           <StatutCandidatureArbitrage userData={props.userData} status={Item}/> 
                                                        </>
                                                    )}
                                                </div>
                                            ))}
                                </>
                                    )}
                        </Accordion.Body>
                    </Accordion.Item>
            ))}
            </Accordion>
            <br/>
        </>
    )}

    </>
  );
}

export default ProchainMatchAffichage;